import React from 'react';
import { Select } from 'antd';
import clsx from 'clsx';
import { isString } from 'src/utils/typeGuards';
import { OptionGroup } from '../services/alertResults.service';
import styles from './AlertResultsFilters.module.less';

type OptionType = {
  value: string | number;
  label: string;
};

type FilterSelectOption = string | OptionType | OptionGroup;

type FilterSelectProps = {
  defaultValue?: string;
  value: string | null;
  label: string;
  options: FilterSelectOption[];
  disabled?: boolean;
  onChange: (value: string) => void;
};

const { Option, OptGroup } = Select;

const renderOption = (item: FilterSelectOption) => {
  if (isString(item)) {
    return (
      <Option key={item} value={item}>
        {item}
      </Option>
    );
  }
  if ('options' in item) {
    return (
      <OptGroup key={item.label} label={item.label}>
        {item.options.map((region) => (
          <Option key={`${item.label}${region.value}`} value={region.value}>
            {region.label}
          </Option>
        ))}
      </OptGroup>
    );
  }
  return (
    <Option key={item.value} value={item.value}>
      {item.label}
    </Option>
  );
};

export const FilterSelect = ({ defaultValue, value, label, options, disabled, onChange }: FilterSelectProps) => {
  return (
    <div className={clsx(styles.formRow, disabled && styles.disabled)}>
      <label>{label}</label>
      <Select onChange={onChange} value={value ?? defaultValue} allowClear={!defaultValue} disabled={disabled}>
        {options?.map(renderOption)}
      </Select>
    </div>
  );
};
